import axios from 'axios';
// import {REACT_APP_SERVER_URI} from '../config';

// axios.defaults.baseURL = REACT_APP_SERVER_URI;
axios.defaults.baseURL = '/api/v1'

export default axios;
